import { resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, createElementVNode as _createElementVNode, withModifiers as _withModifiers, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
var _hoisted_1 = {
  "class": "mb-8 text-3xl font-bold"
};
var _hoisted_2 = /*#__PURE__*/_createTextVNode("Users");
var _hoisted_3 = /*#__PURE__*/_createElementVNode("span", {
  "class": "text-indigo-400 font-medium"
}, "/", -1);
var _hoisted_4 = /*#__PURE__*/_createTextVNode(" Create ");
var _hoisted_5 = {
  "class": "max-w-3xl bg-white rounded-md shadow overflow-hidden"
};
var _hoisted_6 = {
  "class": "flex flex-wrap -mb-8 -mr-6 p-8"
};
var _hoisted_7 = /*#__PURE__*/_createElementVNode("option", {
  value: "admin"
}, "ADMIN", -1);
var _hoisted_8 = /*#__PURE__*/_createElementVNode("option", {
  value: "dgm"
}, "DGM", -1);
var _hoisted_9 = /*#__PURE__*/_createElementVNode("option", {
  value: "sbu_head"
}, "SBU HEAD", -1);
var _hoisted_10 = /*#__PURE__*/_createElementVNode("option", {
  value: "team_lead"
}, "TEAM LEAD", -1);
var _hoisted_11 = {
  "class": "flex items-center justify-end px-8 py-4 bg-gray-50 border-t border-gray-100"
};
var _hoisted_12 = /*#__PURE__*/_createTextVNode("Create User");
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  var _component_Head = _resolveComponent("Head");
  var _component_Link = _resolveComponent("Link");
  var _component_text_input = _resolveComponent("text-input");
  var _component_select_input = _resolveComponent("select-input");
  var _component_file_input = _resolveComponent("file-input");
  var _component_loading_button = _resolveComponent("loading-button");
  return _openBlock(), _createElementBlock("div", null, [_createVNode(_component_Head, {
    title: "Create User"
  }), _createElementVNode("h1", _hoisted_1, [_createVNode(_component_Link, {
    "class": "text-indigo-400 hover:text-indigo-600",
    href: "/users"
  }, {
    "default": _withCtx(function () {
      return [_hoisted_2];
    }),
    _: 1
  }), _hoisted_3, _hoisted_4]), _createElementVNode("div", _hoisted_5, [_createElementVNode("form", {
    onSubmit: _cache[6] || (_cache[6] = _withModifiers(function () {
      return $options.store && $options.store.apply($options, arguments);
    }, ["prevent"]))
  }, [_createElementVNode("div", _hoisted_6, [_createVNode(_component_text_input, {
    modelValue: $data.form.first_name,
    "onUpdate:modelValue": _cache[0] || (_cache[0] = function ($event) {
      return $data.form.first_name = $event;
    }),
    error: $data.form.errors.first_name,
    "class": "pb-8 pr-6 w-full lg:w-1/2",
    label: "First name"
  }, null, 8, ["modelValue", "error"]), _createVNode(_component_text_input, {
    modelValue: $data.form.last_name,
    "onUpdate:modelValue": _cache[1] || (_cache[1] = function ($event) {
      return $data.form.last_name = $event;
    }),
    error: $data.form.errors.last_name,
    "class": "pb-8 pr-6 w-full lg:w-1/2",
    label: "Last name"
  }, null, 8, ["modelValue", "error"]), _createVNode(_component_text_input, {
    modelValue: $data.form.email,
    "onUpdate:modelValue": _cache[2] || (_cache[2] = function ($event) {
      return $data.form.email = $event;
    }),
    error: $data.form.errors.email,
    "class": "pb-8 pr-6 w-full lg:w-1/2",
    label: "Email"
  }, null, 8, ["modelValue", "error"]), _createVNode(_component_text_input, {
    modelValue: $data.form.password,
    "onUpdate:modelValue": _cache[3] || (_cache[3] = function ($event) {
      return $data.form.password = $event;
    }),
    error: $data.form.errors.password,
    "class": "pb-8 pr-6 w-full lg:w-1/2",
    type: "password",
    autocomplete: "new-password",
    label: "Password"
  }, null, 8, ["modelValue", "error"]), _createVNode(_component_select_input, {
    modelValue: $data.form.user_type,
    "onUpdate:modelValue": _cache[4] || (_cache[4] = function ($event) {
      return $data.form.user_type = $event;
    }),
    error: $data.form.errors.user_type,
    "class": "pb-8 pr-6 w-full lg:w-1/2",
    label: "User Type"
  }, {
    "default": _withCtx(function () {
      return [_hoisted_7, _hoisted_8, _hoisted_9, _hoisted_10];
    }),
    _: 1
  }, 8, ["modelValue", "error"]), _createVNode(_component_file_input, {
    modelValue: $data.form.photo,
    "onUpdate:modelValue": _cache[5] || (_cache[5] = function ($event) {
      return $data.form.photo = $event;
    }),
    error: $data.form.errors.photo,
    "class": "pb-8 pr-6 w-full lg:w-1/2",
    type: "file",
    accept: "image/*",
    label: "Photo"
  }, null, 8, ["modelValue", "error"])]), _createElementVNode("div", _hoisted_11, [_createVNode(_component_loading_button, {
    loading: $data.form.processing,
    "class": "btn-indigo",
    type: "submit"
  }, {
    "default": _withCtx(function () {
      return [_hoisted_12];
    }),
    _: 1
  }, 8, ["loading"])])], 32)])]);
}